"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = comparator;

var gt = function gt(a, b) {
  return a > b;
};

var gte = function gte(a, b) {
  return a >= b;
};

var lt = function lt(a, b) {
  return a < b;
};

var lte = function lte(a, b) {
  return a <= b;
};

var eq = function eq(a, b) {
  return a === b;
};

var ne = function ne(a, b) {
  return a !== b;
};

var $in = function $in(a, arr) {
  return arr.includes(a);
};

var nin = function nin(a, arr) {
  return !arr.includes(a);
};

var compareOperations = {
  gt: gt,
  '>': gt,
  gte: gte,
  '>=': gte,
  lt: lt,
  '<': lt,
  lte: lte,
  '<=': lte,
  eq: eq,
  '=': eq,
  '==': eq,
  '===': eq,
  ne: ne,
  '!=': ne,
  '!==': ne,
  in: $in,
  nin: nin
};

function comparator(a, operator, b) {
  var cfn = compareOperations[operator];
  return cfn === undefined ? false : cfn(a, b);
}